export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/downloadIcon.f6a3e089.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};